import React, { Component } from 'react'
import PropTypes from 'prop-types'
import EditIcon from '@material-ui/icons/BorderColor'
import PersonAddIcon from '@material-ui/icons/PersonAdd'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Modal from '@material-ui/core/Modal'
import Button from '@material-ui/core/Button'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { format, subDays } from 'date-fns'
import Fab from '@material-ui/core/Fab'
import IconButton from '@material-ui/core/IconButton'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Grid from '@material-ui/core/Grid'
import DateFnsUtils from '@date-io/date-fns'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers'
import DeleteIcon from '@material-ui/icons/Delete'
import RiskModal from './components/RiskModal'
import SyncSummary from './components/SyncSummary'
import SyncWithin7DaysIcon from './components/SyncWithin7DaysIcon'
import AppShell from './components/layout/AppShell'
import PageCard from './components/ui/PageCard'
import StatusBadge from './components/ui/StatusBadge'
import DeviceStatus from './components/ui/DeviceStatus'
import EmptyState from './components/ui/EmptyState'

const styles = (theme) => ({
  fab: {
    position: 'fixed',
    bottom: theme.spacing(4),
    right: theme.spacing(4),
  },
  modal: {
    position: 'absolute',
    width: theme.spacing(50),
    maxWidth: '92vw',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    outline: 'none',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: 18,
  },
  submit: {
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(1),
  },
  grid: {
    marginTop: theme.spacing(1),
    width: '100%',
  },
  textField: {
    margin: 16,
    minWidth: 178,
  },
  toolbar: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
  },
  tableWrap: {
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    minWidth: 1240,
  },
  tablerow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f8faff',
    },
  },
  nameText: {
    fontWeight: 600,
  },
  muted: {
    color: theme.palette.text.secondary,
    fontSize: '0.8rem',
  },
  deviceCell: {
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
  },
  deviceItem: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
  },
  deviceLabel: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
  },
})

function displayName(user) {
  const last = user.lastname || ''
  const first = user.firstname ? user.firstname.replace(/^./, 'O') : ''
  return `${last}${first}`
}

function formatGender(gender) {
  if (!gender) return '—'
  const g = String(gender).toUpperCase()
  if (g === 'M' || g === 'MALE') return '男'
  if (g === 'F' || g === 'FEMALE') return '女'
  return gender
}

function formatLonggoodScore(score) {
  if (score == null || score === '') return '—'
  const n = Number(score)
  if (Number.isNaN(n)) return '—'
  if (Number.isInteger(n)) return String(n)
  return String(Math.round(n * 100) / 100)
}

class Patients extends Component {
  constructor(props) {
    super(props)
    this.setVisible = this.setVisible.bind(this)
  }

  state = {
    selectedStartDate: format(subDays(new Date().setHours(0, 0, 0, 0), 6), 'yyyy-MM-dd'),
    selectedEndDate: format(new Date(), 'yyyy-MM-dd'),
    modalOpen: false,
    deleteOpen: false,
    deleteUserName: null,
    deleteUserID: null,
    editOpen: false,
    editUser: {},
    selectedDownload: {},
    frequency: '1d',
    users: [],
    heart: [],
    predict: [],
    csvData: [],
    csvDataByReceiveDate: [],
    receivedate: null,
    receivedatestart: 3,
    receivedateend: 3,
    group: {},
    visible: false,
    search: '',
    page: 0,
    rowsPerPage: 8,
    actionAnchor: null,
    actionUser: null,
  }

  async getUserProfile() {
    const uniqid = this.props.match.params.uniqid
    try {
      const result = await fetch(`/api/getUserProfile?uniqid=${uniqid}`, {
        mode: 'cors',
        method: 'GET',
      })
      const data = await result.json()
      if (data.success) {
        this.setState({ users: data.data })
      }
    } catch (err) {
      console.log(err)
    }
  }

  async getUserResource({ start, end }) {
    const uniqid = this.props.match.params.uniqid
    try {
      const result = await fetch(
        `/api/getResourceByRange?resource=AECOPD&uniqid=${uniqid}&start=${start}&end=${end}`,
        { mode: 'cors', method: 'GET' },
      )
      const data = await result.json()
      this.setState({ predict: data })
    } catch (err) {
      console.log(err)
    }
  }

  async getUserHeart({ date }) {
    const uniqid = this.props.match.params.uniqid
    try {
      const result = await fetch(
        `/api/getSerialResourceByDate?resource=heart&uniqid=${uniqid}&date=${date}`,
        { mode: 'cors', method: 'GET' },
      )
      const data = await result.json()
      this.setState({ heart: data })
    } catch (err) {
      console.log(err)
    }
  }

  async getGroupData() {
    const uniqid = this.props.match.params.uniqid
    try {
      const result = await fetch(`/api/getGroupData?uniqid=${uniqid}`, {
        mode: 'cors',
        method: 'GET',
      })
      const data = await result.json()
      if (data.success) {
        this.setState({ group: data.data })
      } else {
        this.props.history.push('/groups')
      }
    } catch (err) {
      this.props.history.push('/groups')
    }
  }

  handleStartDateChange = (date) => {
    this.setState({ selectedStartDate: format(date, 'yyyy-MM-dd') })
  }

  handleEndDateChange = (date) => {
    this.setState({ selectedEndDate: format(date, 'yyyy-MM-dd') })
  }

  handleDateChange = (date) => {
    this.setState({ receivedate: date })
  }

  setVisible = (bool) => {
    this.setState({ visible: bool })
  }

  componentDidMount() {
    this.getGroupData()
    this.getUserProfile()
    const start = format(new Date(), 'yyyy-MM-dd')
    const end = format(new Date(), 'yyyy-MM-dd')
    const date = format(new Date(), 'yyyy-MM-dd')
    this.getUserResource({ start, end })
    this.getUserHeart({ date })
  }

  handleModalOpen = () => this.setState({ modalOpen: true })
  handleModalClose = () => this.setState({ modalOpen: false })

  handleEditOpen = (e, user) => {
    if (e) e.stopPropagation()
    this.setState({
      editOpen: true,
      editUser: user,
      actionAnchor: null,
      actionUser: null,
    })
  }

  handleEditClose = () => this.setState({ editOpen: false })

  handleDeleteOpen = (e, user) => {
    if (e) e.stopPropagation()
    this.setState({
      deleteOpen: true,
      deleteUserName: (user.lastname || '') + (user.firstname || ''),
      deleteUserID: user.id,
      actionAnchor: null,
      actionUser: null,
    })
  }

  handleDeleteClose = () => this.setState({ deleteOpen: false })

  handleFrequencyChange = (event) => {
    this.setState({ frequency: event.target.value })
  }

  toggleDownload = (user_id) => {
    const newSelected = Object.assign({}, this.state.selectedDownload)
    newSelected[user_id] = !this.state.selectedDownload[user_id]
    this.setState({ selectedDownload: newSelected })
  }

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value })
  }

  goToDashboard = (e, id) => {
    const uniqid = this.props.match.params.uniqid
    this.props.history.push(`/${uniqid}/${id}/dashboard/fitbit`)
  }

  handleSearchChange = (e) => {
    this.setState({ search: e.target.value, page: 0 })
  }

  handleChangePage = (event, page) => {
    this.setState({ page })
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 })
  }

  openActionMenu = (e, user) => {
    e.stopPropagation()
    this.setState({ actionAnchor: e.currentTarget, actionUser: user })
  }

  closeActionMenu = () => {
    this.setState({ actionAnchor: null, actionUser: null })
  }

  getPredictMap() {
    const map = {}
    this.state.predict.forEach((i) => {
      const values = Object.values(i)
      const name = values[2]
      const percent = values[4] && values[4][0]
      map[name] = percent === undefined || percent === -1 ? '無' : percent
    })
    return map
  }

  getHeartMap() {
    const map = {}
    this.state.heart.forEach((i) => {
      const values = i.data.map((v) => v.value)
      if (values.length >= 1) {
        map[i.name] = (values.reduce((a, b) => a + b) / values.length).toFixed(1)
      } else {
        map[i.name] = '無'
      }
    })
    return map
  }

  getFilteredUsers() {
    const q = (this.state.search || '').trim().toLowerCase()
    if (!q) return this.state.users
    return this.state.users.filter((u) => {
      const name = displayName(u).toLowerCase()
      const email = (u.email || '').toLowerCase()
      const phone = (u.phone || '').toLowerCase()
      const serial = (u.serial_number || '').toLowerCase()
      return name.includes(q) || email.includes(q) || phone.includes(q) || serial.includes(q)
    })
  }

  getAvgHeart(heartMap) {
    const nums = Object.values(heartMap)
      .map((v) => Number(v))
      .filter((v) => !Number.isNaN(v))
    if (!nums.length) return '—'
    return (nums.reduce((a, b) => a + b, 0) / nums.length).toFixed(1)
  }

  render() {
    const { classes } = this.props
    const { receivedate } = this.state
    const uniqid = this.props.match.params.uniqid
    let group_name = this.state.group.name
    if (typeof group_name === 'string') {
      group_name = group_name.trim()
    }

    const predictMap = this.getPredictMap()
    const heartMap = this.getHeartMap()
    const filtered = this.getFilteredUsers()
    const avgHeart = this.getAvgHeart(heartMap)

    return (
      <AppShell
        uniqid={uniqid}
        title={this.state.group.name || '成員總覽'}
        subtitle={this.state.group.description || '群組成員與同步狀態'}
      >
        <SyncSummary users={this.state.users} avgHeart={avgHeart} />

        <PageCard>
          <div className={classes.toolbar}>
            <Typography variant="subtitle1">成員列表（{filtered.length}）</Typography>
          </div>

          {filtered.length === 0 ? (
            <EmptyState title="找不到成員" description="調整搜尋條件，或新增個案到此群組" />
          ) : (
            <div className={classes.tableWrap}>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>成員</TableCell>
                    <TableCell align="center">健康狀態</TableCell>
                    <TableCell align="center">風險</TableCell>
                    <TableCell align="center">平均心率</TableCell>
                    <TableCell align="center">LongGood Score</TableCell>
                    <TableCell align="center">穿戴裝置</TableCell>
                    <TableCell align="center">性別</TableCell>
                    <TableCell align="center">身高</TableCell>
                    <TableCell align="center">體重</TableCell>
                    <TableCell>聯絡方式</TableCell>
                    <TableCell align="center">七天內同步</TableCell>
                    <TableCell align="right">操作</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filtered.map((row) => {
                    const fullName = `${row.lastname || ''}${row.firstname || ''}`
                    const heart = heartMap[fullName]
                    const heartHigh = heart !== '無' && heart > 80

                    return (
                      <TableRow
                        key={row.id}
                        className={classes.tablerow}
                        onClick={(e) => this.goToDashboard(e, row.id)}
                      >
                        <TableCell>
                          <Typography className={classes.nameText}>{displayName(row)}</Typography>
                        </TableCell>
                        <TableCell align="center">
                          <StatusBadge
                            label={
                              heart === '無' || heart === undefined
                                ? '—'
                                : heartHigh
                                  ? '異常'
                                  : '良好'
                            }
                            tone={
                              heart === '無' || heart === undefined
                                ? 'muted'
                                : heartHigh
                                  ? 'bad'
                                  : 'good'
                            }
                          />
                        </TableCell>
                        <TableCell align="center">
                          <StatusBadge label="—" tone="muted" />
                        </TableCell>
                        <TableCell align="center">
                          {heart === '無' || heart === undefined ? '—' : `${heart} bpm`}
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="body2">{formatLonggoodScore(row.longgood_score)}</Typography>
                          {row.longgood_execute_time ? (
                            <Typography className={classes.muted}>
                              {format(new Date(row.longgood_execute_time), 'yyyy/MM/dd')}
                            </Typography>
                          ) : null}
                        </TableCell>
                        <TableCell align="center">
                          <div className={classes.deviceCell}>
                            <span className={classes.deviceItem}>
                              <span className={classes.deviceLabel}>Google Health</span>
                              <DeviceStatus active={!!(row.user_id || row.health_connected)} />
                            </span>
                            <span className={classes.deviceItem}>
                              <span className={classes.deviceLabel}>Garmin</span>
                              <DeviceStatus active={!!row.garmin_id} />
                            </span>
                            <span className={classes.deviceItem}>
                              <span className={classes.deviceLabel}>龍骨王</span>
                              <DeviceStatus active={!!row.longgood_connected} />
                            </span>
                          </div>
                        </TableCell>
                        <TableCell align="center">{formatGender(row.gender)}</TableCell>
                        <TableCell align="center">{row.height != null && row.height !== '' ? row.height : '—'}</TableCell>
                        <TableCell align="center">{row.weight != null && row.weight !== '' ? row.weight : '—'}</TableCell>
                        <TableCell>
                          <Typography variant="body2">{row.email || '—'}</Typography>
                          <Typography className={classes.muted}>{row.phone || '—'}</Typography>
                        </TableCell>
                        <TableCell align="center">
                          <SyncWithin7DaysIcon lastsynctime={row.lastsynctime} />
                          <Typography className={classes.muted}>
                            {row.lastsynctime
                              ? format(new Date(row.lastsynctime), 'yyyy/MM/dd')
                              : '從未同步'}
                          </Typography>
                        </TableCell>
                        <TableCell align="right" onClick={(e) => e.stopPropagation()}>
                          <IconButton size="small" onClick={(e) => this.openActionMenu(e, row)}>
                            <MoreVertIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </div>
          )}
        </PageCard>

        <Fab className={classes.fab} color="primary" onClick={this.handleModalOpen}>
          <PersonAddIcon />
        </Fab>

        <Menu
          anchorEl={this.state.actionAnchor}
          open={Boolean(this.state.actionAnchor)}
          onClose={this.closeActionMenu}
        >
          <MenuItem
            onClick={(e) => this.handleEditOpen(e, this.state.actionUser)}
          >
            <EditIcon fontSize="small" style={{ marginRight: 8 }} />
            修改
          </MenuItem>
          <MenuItem
            onClick={(e) => this.handleDeleteOpen(e, this.state.actionUser)}
          >
            <DeleteIcon fontSize="small" style={{ marginRight: 8 }} />
            移除
          </MenuItem>
        </Menu>

        <Modal open={this.state.modalOpen} onClose={this.handleModalClose}>
          <div className={classes.modal}>
            <Typography variant="h6">新增個案</Typography>
            <form method="post" action="/api/addUserToGroup">
              <Input type="hidden" id="uniqid" name="uniqid" value={uniqid} />
              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="email">Email</InputLabel>
                <Input id="email" name="email" />
              </FormControl>
              <FormControl margin="normal" fullWidth>
                <InputLabel htmlFor="csn">Airbox流水號</InputLabel>
                <Input id="csn" name="csn" />
              </FormControl>
              <FormControl margin="normal" fullWidth>
                <InputLabel htmlFor="serial_number">個案編號</InputLabel>
                <Input id="serial_number" name="serial_number" />
              </FormControl>
              <FormControl margin="normal" fullWidth>
                <InputLabel htmlFor="order">排序</InputLabel>
                <Input id="order" name="order" />
              </FormControl>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container className={classes.grid}>
                  <DatePicker
                    margin="normal"
                    label="收案日期"
                    style={{ width: '100%', margin: 0, marginTop: 12 }}
                    value={receivedate}
                    onChange={this.handleDateChange}
                  />
                </Grid>
              </MuiPickersUtilsProvider>
              <Input type="hidden" id="receivedate" name="receivedate" value={receivedate} />
              <Button onClick={this.handleModalClose} className={classes.submit}>
                取消
              </Button>
              <Button type="submit" color="primary" variant="contained" className={classes.submit}>
                加入
              </Button>
            </form>
          </div>
        </Modal>

        <Dialog open={this.state.editOpen} onClose={this.handleEditClose} maxWidth="xs" fullWidth>
          <DialogTitle>更新個案資料</DialogTitle>
          <form method="post" action="/api/updateProfile">
            <DialogContent>
              <Typography variant="h6">
                {`${this.state.editUser.lastname || ''}${this.state.editUser.firstname || ''}`}
              </Typography>
              <Input type="hidden" id="id" name="id" value={this.state.editUser.id} />
              <Input type="hidden" id="uniqid" name="uniqid" value={uniqid} />
              <FormControl margin="normal" fullWidth>
                <InputLabel htmlFor="serial_number">個案編號</InputLabel>
                <Input id="serial_number" name="serial_number" autoFocus />
              </FormControl>
              <FormControl margin="normal" fullWidth>
                <InputLabel htmlFor="csn">Airbox流水號</InputLabel>
                <Input id="csn" name="csn" />
              </FormControl>
              <FormControl margin="normal" fullWidth>
                <InputLabel htmlFor="order">排序</InputLabel>
                <Input id="order" name="order" />
              </FormControl>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container className={classes.grid}>
                  <DatePicker
                    margin="normal"
                    label="收案日期"
                    style={{ width: '100%', margin: 0, marginTop: 12 }}
                    value={receivedate}
                    onChange={this.handleDateChange}
                  />
                </Grid>
              </MuiPickersUtilsProvider>
              <Input type="hidden" id="receivedate" name="receivedate" value={receivedate} />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleEditClose} color="primary">
                取消
              </Button>
              <Button type="submit" color="primary" variant="contained">
                更新
              </Button>
            </DialogActions>
          </form>
        </Dialog>

        <Dialog open={this.state.deleteOpen} onClose={this.handleDeleteClose}>
          <form method="post" action="/api/deleteUserFromGroup">
            <Input type="hidden" id="uniqid" name="uniqid" value={uniqid} />
            <Input type="hidden" id="id" name="id" value={this.state.deleteUserID} />
            <DialogTitle>
              確認從【{group_name}】移除個案【{this.state.deleteUserName}】
            </DialogTitle>
            <DialogActions>
              <Button onClick={this.handleDeleteClose} color="primary">
                取消
              </Button>
              <Button onClick={this.handleDeleteClose} color="primary" type="submit" autoFocus>
                確認
              </Button>
            </DialogActions>
          </form>
        </Dialog>

        {this.state.users.length > 0 ? (
          <RiskModal
            patients={this.state.users.filter((item) => {
              const fullName = `${item.lastname || ''}${item.firstname || ''}`
              const predict = predictMap[fullName]
              return predict !== '無' && predict > 0.6
            })}
            visible={this.state.visible}
            setVisible={this.setVisible}
          />
        ) : null}
      </AppShell>
    )
  }
}

Patients.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Patients)
